module.exports = {"engine":{"size":"%{displacement}L %{cylinders}cyl.","sizeTurbo":"%{displacement}L %{cylinders}cyl. turbo","power":"%{hp}hp / %{torque}lb. ft. torque"},"transmission":{"types":"%{type}","speeds":"%{speeds} speed","cvt":"%{type} CVT","typesSpeeds":"%{type} %{speeds} speed"},"fuel":{"city":"City: ","highway":"Hwy: ","100km":"L / 100km"}}


//////////////////
// WEBPACK FOOTER
// ./src/ModelYear/i18n/en.json
// module id = ./src/ModelYear/i18n/en.json
// module chunks = widget-7.1.6